import smc from '../images/clients/smc.png';
import ITC from '../images/clients/ITC.png';
import ITCSparsh from '../images/clients/itc-sparsh.jpg';
import RandPumps from '../images/clients/rand-pumps.png';
import HoneBelrise from '../images/clients/hone-belrise.png';
import McdTrade from '../images/clients/mcd-trade.png';
import mothersparsh from '../images/clients/mothersparsh.avif';
import tradeimpex from '../images/clients/tradeimpex.png';
import rand from '../images/clients/rand.png';
import pumps from '../images/clients/pumps.png';
import hone from '../images/clients/H-One .png';
import belrise from '../images/clients/Belrise.png';
import mcd from '../images/clients/IMCD.png';
import alive from '../images/clients/alive.jpg';
import dsgroup from '../images/clients/dsgroup.png';
import jktyre from '../images/clients/jktyre.jpg';
import lionservices from '../images/clients/lionservices.png';
import maxhealthcare from '../images/clients/maxhealthcare.svg';
import unominda from '../images/clients/unominda.png';
import paytm from '../images/clients/paytm.svg';
import dentsu from '../images/clients/dentsu1.png';
import sandhar from '../images/clients/sandhar.png';

export const clients = [
    {
        id: 1,
        name: "Mother Sparsh",
        img1: ITC,
        img2: mothersparsh,
        bigImg: ITCSparsh,
        url: 'https://mothersparsh.com/',
        about: 'Exclusive Sell-Side Advisor',
        homeheading: 'FundRaise (Round 1 & 2)',
        industry: 'Retails & E-commerce',
    },
    {
        id: 2,
        name: "SMC",
        img1: rand,
        img2: pumps,
        bigImg: RandPumps,
        url: 'https://www.smctradeonline.com/',
        about: 'Exclusive Sell-Side Advisor',
        homeheading: `Sell Side Advisory –
US$ 12 Mn.`,
        industry: 'Finance'
    },
    {
        id: 3,
        name: "Trade Impex",
        img1: belrise,
        img2: hone,
        bigImg: HoneBelrise,
        url: 'https://www.tradeimpexpolymers.com/',
        about: 'Exclusive Buy-Side Advisor',
        homeheading: 'Exclusive Buy-Side Advisor',
        industry: 'Sales & Distribution'
    },
    {
        id: 1,
        name: "Alive Wellness",
        img1: mcd,
        img2: tradeimpex,
        bigImg: McdTrade,
        url: 'https://alivewellnessclinics.com/',
        about: 'Exclusive Sell-Side Advisor',
        homeheading: `Sell Side Advisory – (Round 1 & 2)
US$ 50 Mn`,
        industry: 'Retails & E-commerce',
    },
    // {
    //     id: 2,
    //     name: "Ds Group",
    //     img: dsgroup,
    //     url: 'https://www.dsgroup.com/',
    //     about: 'The DS Group is a Multi-Business Corporation and one of the leading FMCG conglomerate with strong Indian and International presence.',
    //     industry: 'Finance'
    // },
    // {
    //     id: 2,
    //     name: "JK Tyre",
    //     img: jktyre,
    //     url: 'https://www.jktyre.com/',
    //     about: 'The flagship company of JK Organisation, JK Tyre & Industries Ltd is one of India’s foremost tyre manufacturers and is also amongst the top 25 manufacturers in the world.',
    //     industry: 'Finance'
    // },
    // {
    //     id: 2,
    //     name: "Lion Services",
    //     img: lionservices,
    //     url: 'https://www.lionservice.com/',
    //     about: 'Lion Services Ltd. (LSL), the flagship company of Global Excellence Group, is a pioneer in providing environmental hygiene services.',
    //     industry: 'Finance'
    // },
    // {
    //     id: 2,
    //     name: "Max Healthcare",
    //     img: maxhealthcare,
    //     url: 'https://www.maxhealthcare.in/',
    //     about: 'is one of India’s largest healthcare organizations. We operate 19 healthcare facilities (4000+ beds), 30+ specialities and 5000+ clinicians.',
    //     industry: 'Finance'
    // },
    // {
    //     id: 2,
    //     name: "Uno Minda",
    //     img: unominda,
    //     url: 'https://www.unominda.com/',
    //     about: 'Uno Minda Limited (formerly Minda Industries Limited) is a leading global manufacturer of proprietary automotive solutions and systems supplying to OEMs as Tier-1.',
    //     industry: 'Finance'
    // },
    // {
    //     id: 2,
    //     name: "Paytm",
    //     img: paytm,
    //     url: 'https://paytm.com/',
    //     about: 'Pay anyone, everywhere. Make contactless & secure payments in-stores or online.',
    //     industry: 'Finance'
    // },
    // {
    //     id: 2,
    //     name: "Dentsu",
    //     img: dentsu,
    //     url: 'https://www.dentsu.com/',
    //     about: 'Dentsu is an integrated growth and transformation partner to the world’s leading organizations. Founded in 1901 in Tokyo, Japan, and now present in over 145 countries and regions.',
    //     industry: 'Finance'
    // },
    // {
    //     id: 2,
    //     name: "Sandhar",
    //     img: sandhar,
    //     url: 'https://sandhargroup.com/',
    //     about: 'At Sandhar, we focus on customer centric components, mainly catering to Original Equipment Manufacturers (OEM). With a unique motto of ‘Growth.',
    //     industry: 'Finance'
    // },
]